"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var provide_in_when_on_syntax_1 = require("../syntax/provide_in_when_on_syntax");
var provide_when_syntax_1 = require("../syntax/provide_when_syntax");
var provide_on_syntax_1 = require("../syntax/provide_on_syntax");
var provide_in_syntax_1 = require("../syntax/provide_in_syntax");
var provide_done_syntax_1 = require("../syntax/provide_done_syntax");
function fluentProvide(container) {
    // function is named for testing
    return function _fluentProvide(serviceIdentifier) {
        var bindingWhenOnSyntax = container.bind(serviceIdentifier).to(null);
        var binding = bindingWhenOnSyntax._binding;
        var provideDoneSyntax = new provide_done_syntax_1.default(binding);
        var provideInWhenOnSyntax = new provide_in_when_on_syntax_1.default(new provide_in_syntax_1.default(bindingWhenOnSyntax, provideDoneSyntax), new provide_when_syntax_1.default(bindingWhenOnSyntax, provideDoneSyntax), new provide_on_syntax_1.default(bindingWhenOnSyntax, provideDoneSyntax));
        return provideInWhenOnSyntax;
    };
}
exports.default = fluentProvide;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inversify-binding-decorators/lib/decorator/fluent_provide.js
// module id = 1175
// module chunks = 0